import React from 'react';
import Article from './Article.jsx';
import Teaser from './Teaser.jsx';
import {Constants} from '../view-constants';
import {DefaultFallback} from '@shopping-funnel/scripts/components/fallbacks/DefaultFallback.jsx';

function Alpi({
    alpiGiven,
    shopContent,
    positionIndex,
    positionOnPage,
    positionInList,
    pointOfSaleId,
    filterTrackingValue,
    rankingTrackingValue,
    teaserContent,
    filterTokens
}) {
    const renderArticle = () => {
        if (alpiGiven.gridItem.displayType !== Constants.GRIDITEM_ARTICLE) {
            return null;
        }

        return (
            <DefaultFallback>
                <Article
                    givenAlpi={alpiGiven}
                    shopContent={shopContent}
                    positionIndex={positionIndex}
                    positionOnPage={positionOnPage}
                    positionInList={positionInList}
                    pointOfSaleId={pointOfSaleId}
                    filterTrackingValue={filterTrackingValue}
                    rankingTrackingValue={rankingTrackingValue}
                    filterTokens={filterTokens}
                />
            </DefaultFallback>
        );
    }

    if (!alpiGiven.gridItem) {
        return <></>;
    }

    const clazzes = 'alpi ' + (alpiGiven.classes ? alpiGiven.classes : '');

    if (alpiGiven.gridItem.displayType === Constants.GRIDITEM_TEASER) {
        return <Teaser teaserModel={alpiGiven.gridItem.teaserModel} clazzes={clazzes} pageModel={teaserContent} />;
    }

    return <>{renderArticle()}</>;
}

export default React.memo(Alpi);
